export default __webpack_public_path__ + "static/media/sign-up-screenshotfr.bddd79e2.png";